module.exports = __webpack_public_path__ + "img/sv60.091718ae.svg";